import Text from '@/shared-components/text/components/Text';

import './styles/ArtlistOption.css';

export default function ArtlistOption({ text, icon, onClick }) {
  return (
    <button type="button" className="artlist-options__option" onClick={onClick} role="menuitem">
      <Text className="artlist-options__option-text">
        {text}
      </Text>

      {icon}
    </button>
  );
}
